import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'frontbucket.profile.repositories.pageTitle',
    description: 'Title for the profile repositories list',
    defaultMessage: 'Repositories',
  },
});
